export default "__VITE_ASSET__d3TcCN2A__"